import script from "./fileDispositiviPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./fileDispositiviPage.vue?vue&type=script&setup=true&lang=ts"

import "./fileDispositiviPage.vue?vue&type=style&index=0&id=43ab2af0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-43ab2af0"]])

export default __exports__